// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"95":"61ae1fea","857":"1c8f418b"}[chunkId] + ".js";
};